import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import useI18n from '@/mixins/useI18n';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectActionApplyOfferRules',
  emits: ['accept'],
  setup(__props, { emit }) {


const { t } = useI18n();
const { tUser } = useUser('self');

return { __sfc: true,emit, t, tUser, BCXMarkdown }
}

})